import React from 'react';

// TODO verify the necessity of this
export default function CustomTextInput(props) {
	const { name, value, placeholder, type, onChange, onFocus, onBlur, ...rest } = props

	return (
		<input
			type={type}
			name={name}
			placeholder={placeholder}
			value={value}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
			{...rest}
		/>
	);
}
